// GENERATED FILE. Do not edit by hand. Produced by `bun run codegen`.

import Ajv from "ajv";
import addFormats from "ajv-formats";
import call from "../../sdk-helpers/call";
import { logError } from "../../sdk-helpers/shouldLog";

export type typeFanFollowRequestBody = {
  accountId: string;
};

export type typeFanFollowRequestOutput200 = {
  error?: {
    code: string;
    message: string;
    details?: Record<string, unknown>;
  } | null;
  data?: null | { followState: "none" | "requested" | "following" };
};

export type typeFanFollowRequestOutput400 = {
  error: {
    code: string;
    message: string;
    details?: Record<string, unknown>;
  } | null;
  data: null;
};

export type typeFanFollowRequestOutput401 = {
  error: {
    code: string;
    message: string;
    details?: Record<string, unknown>;
  } | null;
  data: null;
};

export type typeFanFollowRequestOutput500 = {
  error: {
    code: string;
    message: string;
    details?: Record<string, unknown>;
  } | null;
  data: null;
};

export const schemaFanFollowRequestBody = {
  type: "object",
  properties: { accountId: { type: "string", maxLength: 3000, minLength: 1 } },
  required: ["accountId"],
} as const;

export type SdkOptions = {
  headers?: Record<string, string>;
  apiHost?: string;
  prefix?: string;
};

let compiledValidator: ReturnType<Ajv["compile"]> | null = null;

export default function createFanFollowRequest(options: SdkOptions) {
  if (!compiledValidator) {
    const ajv = new Ajv({ strict: false });
    addFormats(ajv);
    compiledValidator = ajv.compile(schemaFanFollowRequestBody);
  }

  return async function postFanFollowRequest(
    payload: typeFanFollowRequestBody,
  ): Promise<typeFanFollowRequestOutput200 | typeFanFollowRequestOutput400> {
    const isValid = compiledValidator!(payload);
    if (!isValid) {
      logError(
        `Payload validation inside SDK method "postFanFollowRequest" failed before calling the network. #12f2425b7e79`,
        compiledValidator!.errors,
      );
      return {
        error: {
          code: "VALIDATION_ERROR",
          message: "Request payload failed schema validation.",
          details: { errors: compiledValidator!.errors, ref: "#12f2425b7e79" },
        },
        data: null,
      } as typeFanFollowRequestOutput400;
    }

    const prefix = options?.prefix ?? "";
    return (await call({
      payload,
      endpoint: `${prefix}/fan-follow/request`,
      httpMethod: "POST",
      options,
    })) as typeFanFollowRequestOutput200 | typeFanFollowRequestOutput400;
  };
}
